import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';
import { PaymentGenericError } from 'src/components/PaymentGenericError/PaymentGenericError';
import { ListingProductCode, type ListingProduct } from 'src/generated/graphql';
import { isEmailBoost, isSearchBoost } from 'src/utils/listingProducts';

import { AcceleratePaymentSuccess } from './components/PaymentSuccessScreens/AcceleratePaymentSuccess';
import { EmailBoostPaymentSuccess } from './components/PaymentSuccessScreens/EmailBoostPaymentSuccess';
import { FreemiumPaymentSuccess } from './components/PaymentSuccessScreens/FreemiumPaymentSuccess';
import { GenericRepostPaymentSuccess } from './components/PaymentSuccessScreens/GenericRepostPaymentSuccess';
import { SearchBoostPaymentSuccess } from './components/PaymentSuccessScreens/SearchBoostPaymentSuccess';
import { StandardPaymentSuccess } from './components/PaymentSuccessScreens/StandardPaymentSuccess';

interface PaymentSuccessSingleProductProps {
  clientId: string;
  firstUrlProduct: ListingProduct;
  listingId: string | null;
}

export const PaymentSuccessSingleProduct = (
  props: PaymentSuccessSingleProductProps,
) => {
  if (props.firstUrlProduct.productCode === ListingProductCode.Freemium) {
    if (props.listingId) {
      return (
        <PaymentContainer width="small">
          <GenericRepostPaymentSuccess
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </PaymentContainer>
      );
    }
    return (
      <PaymentContainer width="small">
        <FreemiumPaymentSuccess />
      </PaymentContainer>
    );
  }

  if (props.firstUrlProduct.productCode === ListingProductCode.ListUntilSold) {
    if (props.listingId) {
      return (
        <PaymentContainer width="small">
          <GenericRepostPaymentSuccess
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </PaymentContainer>
      );
    }
    return (
      <PaymentContainer width="medium">
        <StandardPaymentSuccess standardProduct={props.firstUrlProduct} />
      </PaymentContainer>
    );
  }

  if (props.firstUrlProduct.productCode === ListingProductCode.Accelerate) {
    if (props.listingId) {
      return (
        <PaymentContainer width="small">
          <GenericRepostPaymentSuccess
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </PaymentContainer>
      );
    }
    return (
      <PaymentContainer width="medium">
        <AcceleratePaymentSuccess />
      </PaymentContainer>
    );
  }

  if (isEmailBoost(props.firstUrlProduct)) {
    return (
      <PaymentContainer width="medium">
        <EmailBoostPaymentSuccess />
      </PaymentContainer>
    );
  }

  if (isSearchBoost(props.firstUrlProduct)) {
    return (
      <PaymentContainer width="medium">
        <SearchBoostPaymentSuccess />
      </PaymentContainer>
    );
  }

  // TODO unit test
  return <PaymentGenericError testId="single-product-no-match-error" />;
};
